import { always, cond, equals } from "lodash/fp";
import { HostedFieldType } from "@zapier/payment/esm/types";

export const getHostedFieldId = (type: HostedFieldType): string =>
  `__hostedfield__${type}__`;

export const getHostedFieldSelector = (type: HostedFieldType): string =>
  `#${getHostedFieldId(type)}`;

export const getElementPlaceholder = (type: HostedFieldType): string =>
  cond([
    [equals("number"), always("0000 0000 0000 0000")],
    [equals("expiry"), always("MM / YY")],
    [equals("cvc"), always("000")],
  ])(type);
